// src/Views/HomePage.js
import React from "react";
import "./HomePage.css";
import TopFold from "./TopFold";

export default function HomePage() {
  return (
    <div className="cafe-homepage">
      <TopFold />
    </div>
  );
}
